<div *ngIf="crmItem; else errorMsg" class="crm-modal-container">
  <form (ngSubmit)="submit()" class="w-100">
    <div class="crm-modal-header d-flex justify-content-between align-items-center">
      <div>{{ crmItem.companies[0]?.company.name }} <span class="crm-item-name">| {{ crmItem.name }}</span></div>
      <img src="assets/icons/cancel-icon-slim.svg" alt="Cancel Button" (click)="close()"/>
    </div>

    <div class="quick-edit-content">
      <div class="quick-edit-content-action" [ngClass]="{'no-notes': !overviewNote && !crmNote}">
        <div>
          <div class="crm-modal-subheader">{{ "CRM.QUICK_EDIT.QUICK_NOTE" | translate }}</div>
          <textarea class="form-control" [(ngModel)]="noteText" name="note" rows="4"></textarea>
        </div>
        <div class="d-inline-flex align-items-center justify-content-between w-100">
          <button class="btn btn-primary" [disabled]="!noteText" type="submit">{{"GENERICS.SAVE" | translate}}</button>
        </div>
      </div>
      <div *ngIf="overviewNote || crmNote" class="quick-edit-content-notes">
        <div *ngIf="overviewNote" class="quick-edit-content-note">
          <div class="quick-edit-content-note-header">
            <div class="d-inline-flex align-items-center">
              <img *ngIf="overviewNote.textContent.isOverview" src="assets/icons/flask.svg" alt="Overview Note"/>
              <img *ngIf="crmNoteService.isCrmNote(overviewNote.textContent)" src="assets/icons/lightning-bolt.svg" alt="Sonar Note"/>
              <div class="d-inline-flex align-items-center">{{ "CRM.POSTED" | translate }} {{ overviewNote.textContent.timestamp | rmsTzFormat: formatEST: '' | rmsTimeagoExtended }} - {{ overviewNote.textContent.created | date:'shortDate' }}<span class="note-author">by {{getNoteAuthor(overviewNote)}} | <span>{{ "CRM.OVERVIEW_NOTE" | translate }}</span></span></div>
            </div>
            <a class="fa fa-external-link ml-3" [href]="getHref(overviewNote)" target="_blank"></a>
          </div>
          <div class="quick-edit-content-note-content">
            <rms-text-content-body [data]="overviewNote.textContent.content"></rms-text-content-body>
          </div>
        </div>
        <div *ngIf="crmNote" class="quick-edit-content-note">
          <div class="quick-edit-content-note-header">
            <div class="d-inline-flex align-items-center">
              <img *ngIf="crmNote.textContent.isOverview" src="assets/icons/flask.svg" alt="Overview Note"/>
              <img *ngIf="crmNoteService.isCrmNote(crmNote.textContent)" src="assets/icons/lightning-bolt.svg" alt="Sonar Note"/>
              <div class="d-inline-flex align-items-center">{{ "CRM.POSTED" | translate }} {{ crmNote.textContent.timestamp | rmsTzFormat: formatEST: '' | rmsTimeagoExtended }} - {{ crmNote.textContent.created | date:'shortDate' }}<span class="note-author">by {{getNoteAuthor(crmNote)}} | <span>{{ "CRM.SONAR_NOTE" | translate }}</span></span></div>
            </div>
            <a class="fa fa-external-link ml-3" [href]="getHref(crmNote)" target="_blank"></a>
          </div>
          <div class="quick-edit-content-note-content">
            <rms-text-content-body [data]="crmNote.textContent.content"></rms-text-content-body>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer w-100">
      <button class="btn btn-default" type="button" (click)="close()">{{"GENERICS.CANCEL" | translate}}</button>
    </div>
  </form>
</div>

<ng-template #errorMsg>
  {{ "CRM.SOMETHING_WENT_WRONG" | translate }}
</ng-template>
